var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserLogoEtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#513500"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55322 51.9533C14.1594 45.3331 21.8236 41 30.4998 41C38.9253 41 46.3965 45.0863 51.0395 51.3853C45.6248 56.713 38.1962 60 29.9998 60C22.0988 60 14.9111 56.9456 9.55322 51.9533Z",
    fill: "#FEE92B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8828 16.7283L37.9364 13.3697C40.3182 12.0468 43.044 14.5356 41.5951 16.7102L37.9166 22.2375C37.4005 23.0107 37.4005 23.9833 37.9166 24.7625L41.5951 30.2898C43.044 32.4644 40.3182 34.9532 37.9364 33.6303L31.8828 30.2717C31.0359 29.8005 29.9707 29.8005 29.1172 30.2717L23.0636 33.6303C20.6818 34.9532 17.956 32.4644 19.4049 30.2898L23.0834 24.7625C23.5995 23.9893 23.5995 23.0167 23.0834 22.2375L19.4049 16.7102C17.956 14.5356 20.6818 12.0468 23.0636 13.3697L29.1172 16.7283C29.9641 17.1995 31.0293 17.1995 31.8828 16.7283Z",
    fill: "#FEE92B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLogoEtc);
export default __webpack_public_path__ + "static/media/user-logo-etc.12baf06c4e66c8fae3d3207e064664f0.svg";
export { ForwardRef as ReactComponent };